import localforage from "localforage";

const db = localforage.config({
  driver: localforage.INDEXEDDB,
  name: 'iCare'
})

export const getValue = ({ key }) => {
  console.log('key', key)
  try {
    return localforage.getItem(key);
  } catch (e) {
    console.log(e);
    return undefined;
  }
}

export const setValue = ({ key, value }) => localforage.setItem(key, value);

export const getItems = async (prefix) => {
  return new Promise( async (resolve, reject) => {
    const keys = await localforage.keys();
    if (prefix) {
      const filteredKeys = keys.filter(key => key.startsWith(prefix))
      resolve(filteredKeys)
    } else {
      resolve(keys)
    }
  })
}

export const removeItem = ({ id }) => localforage.removeItem(id)

export const getItem = ({ id }) => localforage.getItem(id)

export const getItemsCount = async () => (await getItems()).length

export const getImage = ({ cardId }) => getValue({ key: 'image-' + cardId });

export const isEmpty = async () => (await getItems()).length === 0

export const getJSON = ({ key }) => JSON.parse(localforage.getItem(key))

export const setJSON = ({ key, value }) => localforage.setItem(key, JSON.stringify(value))